import {
  SET_ALL_BLOGS,
  GET_BLOGS,
  SET_ALL_BLOGS_SELECT,
  CREATE_BLOG,
  GET_BLOG,
  UPDATE_BLOG,
} from "../../reducerTypes";

const initialState = {
  getData: {},
  getList: [],
  selectData: [],
};

const blogReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_BLOGS:
      return {
        ...state,
        getList: action.payload,
      };
    case GET_BLOGS:
      return {
        ...state,
        getList: action.payload,
      };
    case SET_ALL_BLOGS_SELECT:
      const contentData = action.payload ? action.payload : [];
      const selectData = [];
      contentData.map((data) => {
        selectData.push({
          value: data.id,
          label: `${data.title}`,
        });
      });
      return {
        ...state,
        selectData: selectData,
      };
    case CREATE_BLOG:
      return {
        ...state,
        getData: action.payload,
      };
    case GET_BLOG:
      return {
        ...state,
        getData: action.payload,
      };
    case UPDATE_BLOG:
      return {
        ...state,
        getData: action.payload,
      };
    default:
      return state;
  }
};

export default blogReducer;
